import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/light.css'
import 'react-toastify/dist/ReactToastify.css';
import './css/ReactSelectSearch.css';
import './css/design-system.css'; // hoja de estilo unificada de toda la plataforma (no toca /login, ver comentario en el archivo)

import App from './App';

//sidebar-toggle
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);